import SoftBadge from "@/components/atoms/SoftBadge";
import PreformatifDiagnosticActions from "@/components/molecules/preformatif-diagnostic/PreformatifDiagnosticActions";
import PreformatifDiagnosticForm from "@/components/molecules/preformatif-diagnostic/PreformatifDiagnosticForm";
import usePreformatifDiagnosticEditor from "@/hooks/usePreformatifDiagnosticEditor";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Alert, Button, Modal } from "react-bootstrap";

export interface PreformatifDiagnosticModalMethods { showOrHiddenModal: (courseId: string) => void; }
interface Props { companyId: string; courseId?: string; onHide?: () => void; }

const PreformatifDiagnosticModal = forwardRef<PreformatifDiagnosticModalMethods, Props>(({ companyId, courseId: initialCourseId, onHide }, ref) => {
  const [courseId, setCourseId] = useState<string | undefined>(initialCourseId);
  const [show, setShow] = useState(!!initialCourseId);
  const editor = usePreformatifDiagnosticEditor(companyId, courseId);
  useImperativeHandle(ref, () => ({ showOrHiddenModal: (id) => { setCourseId(id); setShow(true); } }));
  useEffect(() => { if (initialCourseId) { setCourseId(initialCourseId); setShow(true); } }, [initialCourseId]);
  const hide = () => { setShow(false); onHide?.(); };
  const status = editor.diagnostic?.status;
  return <Modal show={show} onHide={hide} size="xl" centered scrollable aria-labelledby="preformatif-diagnostic-title">
    <Modal.Header closeButton>
      <Modal.Title id="preformatif-diagnostic-title" className="d-flex align-items-center gap-2">
        <FontAwesomeIcon icon={faFileLines} className="text-primary" />Diagnostic préformatif entreprise
        <SoftBadge bg={status === "finalized" ? "success" : status ? "warning" : "secondary"}>{status === "finalized" ? "Finalisé" : status ? "Brouillon" : "Non créé"}</SoftBadge>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <PreformatifDiagnosticForm answers={editor.answers} onChange={editor.setAnswers} header={editor.header} missing={editor.missing} />
      {editor.feedback && <Alert variant={editor.feedback.variant} className="mb-0">{editor.feedback.message}</Alert>}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" className="me-auto" onClick={hide}>Fermer</Button>
      <PreformatifDiagnosticActions editor={editor} />
    </Modal.Footer>
  </Modal>;
});
PreformatifDiagnosticModal.displayName = "PreformatifDiagnosticModal";
export default PreformatifDiagnosticModal;
